module.exports = __webpack_public_path__ + "static/media/light_icn_map_fermata_lex_capolinea_selected.f086aa87.svg";